import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-ep-notification",
  templateUrl: "./ep-notification.component.html",
  styleUrls: ["./ep-notification.component.scss"],
  standalone: false,
})
export class EpNotificationComponent implements OnInit {
  @Input() status: string;
  @Input() title: string;
  @Input() description: string;
  @Input() autoDismiss = 45000; // auto-dismiss after 45s, 0 to disable
  @Output() dismissed = new EventEmitter<void>();

  visible = true;

  ngOnInit() {
    if (this.autoDismiss > 0) {
      setTimeout(() => this.dismiss(), this.autoDismiss);
    }
  }

  dismiss() {
    this.visible = false;
    this.dismissed.emit();
  }
}
